module.exports = __webpack_public_path__ + "img/Button_Back.65b5e28c.png";